import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseHttpService } from '@lbmx/root-services';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-register-wrapper',
  templateUrl: './register-wrapper.component.html',
})
export class RegisterWrapperComponent implements OnInit {
  public showWizard = false;

  constructor(
    private store: Store<any>,
    private http: BaseHttpService,
    private route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.route.queryParams
      .pipe(
        tap((params) => {
          this.showWizard = JSON.parse(params?.wizard || false);
        })
      )
      .subscribe();
  }
}
